import { useEffect } from 'react';
import { useAppSelector } from './Hooks';

export const useTheme = (): void => {
  const theme = useAppSelector((state) => state.theme.theme);

  useEffect(() => {
    document.body.className = `theme_${theme}`;
  }, [theme]);
};